import { sanitizeUrl } from 'javascripts/sanitizer';
import CustomField from '../../CustomField';

export class UrlCustomFieldLink extends CustomField {
  exampleContents() {
    return {
      link: 'aha.io',
      externalUrl: '#',
      linkIcon: true,
    };
  }

  contentsForRecord(record) {
    const customFieldValue = this.customFieldValueForRecord(record);

    if (customFieldValue?.value) {
      return {
        link: customFieldValue.value,
        externalUrl: sanitizeUrl(customFieldValue.value),
        linkIcon: true,
      };
    }

    return {};
  }
}
